

export default theme => ({

    toolbar2: theme.mixins.toolbar,
    content2: {
        backgroundColor: theme.palette.secondary.main,
        flex: 1
    },
    menuItem: {
        color: theme.palette.secondary.contrastText,
    },
});


// WEBPACK FOOTER //
// ./src/App/components/Menu/components/styles.js